export default class Modal {
  constructor (attr) {
    this.id = INKIVE.Math.generateUUID();
    this.options = $.extend({
      skip: true
    }, attr);
  }

  getWrapper () {
    let $wrapper = $('body .modalWrapper[data-id="' + this.id + '"]');

    if (!$wrapper.length) {
      $wrapper = $(INKIVE.TemplatesHelper('modal_wrapper', { id: this.id }));
      $('body').append($wrapper);
    }

    return $wrapper;
  }

  constructModal (dataHtml) {
    this.options = $.extend({
      width: 670
    }, this.options);

    const that = this;
    const $wrapper = this.getWrapper();

    render();
    setEvents();

    function render () {
      const html = INKIVE.TemplatesHelper('modal', {
        id: that.id,
        icon: that.options.headerIcon,
        title: that.options.headerTitle,
        classes: that.options.classes,
        width: 'width: ' + that.options.width + 'px;'
      });

      $wrapper.append(html).find('.modal .content form').append(dataHtml);
      that.options.buttons && addButtons();

      function addButtons () {
        const buttons = _.map(that.options.buttons, getButtonInfo);
        const $list = INKIVE.TemplatesHelper('modal_buttons', buttons);

        $wrapper.find('.modal').append($list);

        function getButtonInfo (button) {
          return _.extend({}, button, {
            class: button.cls ? button.cls : '',
            width: button.width ? 'width: ' + button.width + '; ' : ''
          });
        }
      }
    }

    function setEvents () {
      $wrapper.find('.modal .content form').submit(function (e) {
        e.preventDefault();
      });

      $wrapper.find('.modal .content form input').keyup(function (e) {
        const code = (e.keyCode ? e.keyCode : e.which);
        if (code === 13 || code === 10 || code === 9) {
          $(this).blur();
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

      that.options.skip && $wrapper.find('.modal .modal-header')
        .on('click', _.bind(that.close, that));

      that.options.buttons && setButtonsEvents();

      function setButtonsEvents () {
        const $list = $wrapper.find('.btnWrapper.bottom');

        _.each(that.options.buttons, function (button, i) {
          $list.find('#btn-' + i).on('click', button.onClick);
        });
      }
    }
  }

  constructAlert (message) {
    this.options = $.extend({
      width: 350,
      loader: false,
      message: ['general.yes', 'general.no'],
      callback: []
    }, this.options);

    const that = this;
    const $wrapper = this.getWrapper();

    render();
    that.options.callback.length && setButtonsEvents();
    that.options.loader && INKIVE.SVGElementLoading.show(document.body);

    function render () {
      const html = INKIVE.TemplatesHelper('modal_alert', {
        message,
        width: 'width: ' + that.options.width + 'px;'
      });

      $wrapper.append(html);
      that.options.callback.length && addButtons();

      function addButtons () {
        const buttons = _.map(_.range(that.options.callback.length), getButtonInfo);
        const $list = INKIVE.TemplatesHelper('modal_buttons', buttons);

        $wrapper.find('.modal').append($list);

        const isPair = that.options.callback.length % 2 === 0;
        isPair || $wrapper.find('.btnWrapper.bottom li').last().css('width', '100%');

        function getButtonInfo (index) {
          return {
            class: '',
            title: that.options.message[index]
          };
        }
      }
    }

    function setButtonsEvents () {
      $wrapper.find('.btnWrapper.bottom .btn').on('click', function (e) {
        const callbackId = $(this).attr('id').split('-')[1];
        const callback = that.options.callback[callbackId];

        typeof callback === 'function' && callback();
        that.close();
      });
    }
  }

  show () {
    const that = this;
    const $wrapper = this.getWrapper();
    $wrapper.on('contentChanged', function () {
      that.refresh();
    });

    $wrapper.show();
    // $wrapper.fadeIn('slow');
    $('body > header').addClass('disabled');
    $('aside').addClass('disabled');

    const $elem = $wrapper.find('.modal');

    that.refresh();

    $elem.show();
    // $elem.fadeIn('fast', function(){
    //    $elem.css({
    //        WebkitTransition : 'all 0.3s',
    //        MozTransition    : 'all 0.3s',
    //        transition       : 'all 0.3s'
    //    })
    // });

    function onEsc (e) {
      if (that.options.skip && e.keyCode === 27) {
        that.close();
        $(document).unbind('keydown', onEsc);
      }
    }

    if (that.options.skip) {
      $wrapper.on('click', function (e) {
        if ($(e.target).is($(this))) {
          that.close();
        }
      });

      // ESCAPE key pressed
      $(document).keydown(onEsc);
    }
  }

  refresh () {
    const wrapper = this.getWrapper();
    const $elem = wrapper.find('.modal');

    let marginHeight = ($(window).height() - $elem.height()) / 2 + 10;
    const marginWidth = -$elem.width() / 2;

    if (marginHeight < 0) {
      marginHeight = 0;
    }

    $elem.css('margin-top', marginHeight);
    $elem.css('margin-left', marginWidth);
  }

  close (callback) {
    INKIVE.SVGElementLoading.hide(document.body);
    const $wrapper = $('.modalWrapper[data-id="' + this.id + '"]');
    this.getWrapper().off('click');

    if (typeof callback !== 'function' && this.options && this.options.closeCallback) {
      callback = this.options.closeCallback;
    }

    $wrapper.children(' .modal').transition({ scale: 0 }, 350, function () {
      $wrapper.remove();

      let isLastWrapper = true;
      $('.modalWrapper').each(function () {
        const isEmpty = $(this).is(':empty');
        isEmpty && $(this).remove();
        isLastWrapper &= isEmpty;
      });

      if (isLastWrapper) {
        $('aside').removeClass('disabled');
        $('body > header').removeClass('disabled');
      }

      typeof callback === 'function' && callback();
    });
  }

  toggleLock (status) {
    this.lockStatus = status;
  }

  modalWindow (dataHtml, attr) {
    if (this.lockStatus) return null;

    const modal = new Modal(attr);
    modal.constructModal(dataHtml);
    modal.show();

    return modal;
  }

  // Alert Message
  alertMessage (message, attr) {
    if (this.lockStatus) return null;

    const modal = new Modal(attr);
    modal.constructAlert(message);
    modal.show();

    return modal;
  }

  // Loader
  loader (element) {
    if (element) INKIVE.SVGElementLoading.show(element[0]);

    return element;
  }

  loaderClose (element) {
    if (element) INKIVE.SVGElementLoading.hide(element[0]);
  }

  togglePageLoader (isLoad) {
    if (this.lockStatus) return null;

    if (isLoad) {
      INKIVE.SVGElementLoading.show(document.body);
    } else {
      INKIVE.SVGElementLoading.hide(document.body);
    }
  }

  closeAllPageLoaders () {
    INKIVE.SVGElementLoading.hideAll();
  }
}
